import type {ButtonVariant} from 'shells/button/types';

import {colors} from '../../colors/colors';
import type {Color as BodyColor} from '../../typography/body';
import type {RealAndFakeWidgetType} from '../../widgets/types';

export function getIconColorForWidgetType(type?: RealAndFakeWidgetType | null): string {
    switch (type) {
        case 'AI_SUMMARY':
        case 'NUTSHELL_IQ':
        case 'LEAD_RESEARCHER':
            return colors.aiPurplePrimary;
        default:
            return colors.grey;
    }
}

export function getTitleColorForWidgetType(type?: RealAndFakeWidgetType | null): BodyColor {
    switch (type) {
        case 'AI_SUMMARY':
        case 'NUTSHELL_IQ':
        case 'LEAD_RESEARCHER':
            return 'ai-purple';
        default:
            return 'dark';
    }
}

export function getButtonVariantForWidgetType(type?: RealAndFakeWidgetType | null): ButtonVariant {
    switch (type) {
        case 'NUTSHELL_IQ':
            return 'text-ai';
        default:
            return 'text-primary';
    }
}
